import { confirm, ConfirmCustomizationOptions, DialogResponse } from 'owa-confirm-dialog';
import controlStrings from 'owa-strings/owa-common-strings';
import * as React from 'react';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import strings from 'owa-strings/owa-mail-strings';

export default class IgnoreConversationsConfirmDialog {
    private isChecked: boolean;
    private title: string;
    private subtext: string;
    private onConfirm: (isChecked: boolean) => void;
    private onDismiss: () => void;
    private dialogOptions: ConfirmCustomizationOptions;

    constructor(
        title: string,
        subtext: string,
        onConfirm: (isChecked: boolean) => void,
        onDismiss: () => void
    ) {
        this.title = title;
        this.subtext = subtext;
        this.isChecked = false;
        this.onConfirm = onConfirm;
        this.onDismiss = onDismiss;

        this.dialogOptions = {
            okText: controlStrings.okButton,
            cancelText: controlStrings.cancelButton,
            bodyElement: (
                <Checkbox
                    label={strings.ignore_dontShowAgainCheckbox}
                    onChange={() => {
                        this.isChecked = !this.isChecked;
                    }}
                />
            ),
        };
    }

    public show(): Promise<void> {
        return confirm(this.title, this.subtext, false, this.dialogOptions).then(
            (response: DialogResponse) => {
                if (response === DialogResponse.ok) {
                    return this.onConfirm(this.isChecked);
                } else {
                    return this.onDismiss();
                }
            }
        );
    }
}
